export const EBSColumns = [
  {
    title: 'EBS执行时间',
    dataIndex: 'ebsExecTime',
    width: 140,
    ellipsis: true,
    scopedSlots: { customRender: 'name' },
  },
  {
    title: 'EBS_ID',
    dataIndex: 'ebsId',
    width: 100,
    ellipsis: true,
    scopedSlots: { customRender: 'name' },
  },
  {
    title: 'NHF配方名称',
    dataIndex: 'nhfFormulaName',
    width: 140,
    ellipsis: true,
    scopedSlots: { customRender: 'name' },
  },
  {
    title: 'NHF配方代码',
    dataIndex: 'nhfFormulaCode',
    width: 140,
    ellipsis: true,
    scopedSlots: { customRender: 'name' },
  },
  {
    title: 'EBS执行配方版本',
    dataIndex: 'ebsFormulaVersion',
    width: 100,
    ellipsis: true,
    scopedSlots: { customRender: 'name' },
  },
  {
    title: 'NHF配方版本',
    dataIndex: 'nhfFormulaVersion',
    width: 80,
    ellipsis: true,
    scopedSlots: { customRender: 'name' },
  },
  {
    title: 'EBS配方来源',
    dataIndex: 'ebsFormulaSource',
    width: 80,
    ellipsis: true,
    scopedSlots: { customRender: 'name' },
  },
  {
    title: '执行工厂',
    dataIndex: 'factoryName',
    width: 140,
    ellipsis: true,
    scopedSlots: { customRender: 'name' },
  },
  // {
  //   title: '实体组织编码',
  //   dataIndex: 'ebsEntityCode',
  //   width: 100,
  //   ellipsis: true,
  //   scopedSlots: { customRender: 'name' },
  // },
  {
    title: '库存组织编码',
    dataIndex: 'ebsMaterialCode',
    width: 100,
    ellipsis: true,
    scopedSlots: { customRender: 'name' },
  },
  {
    title: '品管',
    dataIndex: 'qcManager',
    width: 90,
    ellipsis: true,
    scopedSlots: { customRender: 'name' },
  },
  {
    title: '员工编号',
    dataIndex: 'staffCode',
    width: 90,
    ellipsis: true,
    scopedSlots: { customRender: 'name' },
  },
  {
    title: '营养师',
    dataIndex: 'staffName',
    width: 90,
    ellipsis: true,
    scopedSlots: { customRender: 'name' },
  },
  {
    title: '执行明细',
    dataIndex: 'x',
    width: 90,
    ellipsis: true,
    scopedSlots: { customRender: 'x' },
  },
  {
    title: 'NHF推送时间',
    dataIndex: 'formulaPushTime',
    width: 140,
    ellipsis: true,
    scopedSlots: { customRender: 'name' },
  },
  {
    title: '创建时间',
    dataIndex: 'createTime',
    width: 140,
    ellipsis: true,
    scopedSlots: { customRender: 'name' },
  },
]

export const productColumns = [
  {
    title: '序号',
    dataIndex: 'sort',
    width: 50,
    ellipsis: true,
    scopedSlots: { customRender: 'sort' },
  },
  {
    title: 'EBS产品名称',
    dataIndex: 'ebsProductName',
    width: 100,
    ellipsis: true,
    scopedSlots: { customRender: 'name' },
  },
  {
    title: 'EBS产品编码',
    dataIndex: 'ebsProductCode',
    width: 120,
    ellipsis: true,
    scopedSlots: { customRender: 'name' },
  },
  {
    title: '原始数量',
    dataIndex: 'ebsProductBeginWeight',
    width: 140,
    ellipsis: true,
    scopedSlots: { customRender: 'fixed' },
  },
  {
    title: '修改后数量',
    dataIndex: 'ebsProducteditWeight',
    width: 140,
    ellipsis: true,
    scopedSlots: { customRender: 'fixed' },
  },
  {
    title: '修改类型',
    dataIndex: 'ebsProductEditType',
    width: 140,
    ellipsis: true,
    scopedSlots: { customRender: 'typeName' },
  },
]
export const rawsColumns = [
  {
    title: '序号',
    dataIndex: 'sort',
    width: 50,
    ellipsis: true,
    scopedSlots: { customRender: 'sort' },
  },
  {
    title: 'EBS物料名称',
    dataIndex: 'ebsRawName',
    width: 100,
    ellipsis: true,
    scopedSlots: { customRender: 'name' },
  },
  {
    title: 'EBS物料编码',
    dataIndex: 'ebsRawCode',
    width: 140,
    ellipsis: true,
    scopedSlots: { customRender: 'name' },
  },
  {
    title: '原始数量',
    dataIndex: 'ebsRawBeginWeight',
    width: 140,
    ellipsis: true,
    scopedSlots: { customRender: 'fixed' },
  },
  {
    title: '修改后数量',
    dataIndex: 'ebsRawEditWeight',
    width: 140,
    ellipsis: true,
    scopedSlots: { customRender: 'fixed' },
  },
  {
    title: '修改类型',
    dataIndex: 'ebsRawEditType',
    width: 140,
    ellipsis: true,
    scopedSlots: { customRender: 'typeName' },
  },
]